import React from 'react';
import '../Filters/Filters.scss';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { LiaSortDownSolid, LiaSortUpSolid } from 'react-icons/lia';

const SortPopover = ({
  setShowSortPopover,
  expandedSortFieldKey,
  setExpandedSortFieldKey,
  sortableFields = [],
  sortField,
  sortDirection,
  onSortChange
}) => {
  const toggleExpandField = (fieldKey) => {
    const next = expandedSortFieldKey === fieldKey ? null : fieldKey;
    setExpandedSortFieldKey(next);
  };


  const handleSortClick = (fieldName, direction) => {
    // Handle both single and multiple sort scenarios
    const currentSorts = Array.isArray(sortField) ? sortField : 
                       (sortField ? [{ field: sortField, direction: sortDirection }] : []);
    
    const existingSortIndex = currentSorts.findIndex(s => s.field === fieldName && s.direction === direction);
    
    if (existingSortIndex === -1) {
      // Add new sort field with specific direction
      // First remove any existing sort for this field (regardless of direction)
      const filteredSorts = currentSorts.filter(s => s.field !== fieldName);
      // Then add the new sort as primary
      const newSorts = [{ field: fieldName, direction: direction }, ...filteredSorts];
      onSortChange?.(newSorts, 'multiple');
    } else {
      // Remove this specific sort field (same field and direction)
      const newSorts = currentSorts.filter(s => !(s.field === fieldName && s.direction === direction));
      if (newSorts.length === 0) {
        onSortChange?.(null, null);
      } else if (newSorts.length === 1) {
        // Convert back to single format for backward compatibility
        onSortChange?.(newSorts[0].field, newSorts[0].direction);
      } else {
        onSortChange?.(newSorts, 'multiple');
      }
    }
  };

  const getFieldDisplayName = (field) => {
    return field.displayName || field.label || field.name || field.fieldName;
  };

  // Get current sort state for a field
  const getFieldSortState = (fieldName) => {
    const currentSorts = Array.isArray(sortField) ? sortField : 
                       (sortField ? [{ field: sortField, direction: sortDirection }] : []);
    const sortIndex = currentSorts.findIndex(s => s.field === fieldName);
    if (sortIndex === -1) return { isSelected: false, direction: null };
    
    return {
      isSelected: true,
      direction: currentSorts[sortIndex].direction
    };
  };

  if (sortableFields.length === 0) {
    return (
      <div className="sorting-popover filters-popover">
        <div className="filters-popover-header">
          <span>Sort Results</span>
          <button
            type="button"
            className="filters-popover-close"
            onClick={() => setShowSortPopover(false)}
          >
            ×
          </button>
        </div>
        <div className="popover-content">
          <div className="no-sortable-fields">
            <p>No sortable fields available for selected repositories.</p>
            <p>Please select repositories that have common sortable fields.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sorting-popover filters-popover">
      <div className="filters-popover-header">
        <span>Sort Results</span>
        <button
          type="button"
          className="filters-popover-close"
          onClick={() => setShowSortPopover(false)}
        >
          ×
        </button>
      </div>

      <ul className="filters-popover-list">
        {sortableFields.map((field) => {
          const isExpanded = expandedSortFieldKey === field.fieldName;
          const sortState = getFieldSortState(field.fieldName);
          
          return (
            <li key={field.fieldName} className="filters-popover-row">
              <div className="filters-popover-item">
                <div className="sort-field-info">
                  <span className="sort-field-name">{getFieldDisplayName(field)}</span>
                  {field.description && (
                    <span 
                      className="filters-popover-chevron"
                      onClick={() => toggleExpandField(field.fieldName)}
                    >
                      {isExpanded ? <MdKeyboardArrowDown className='filters-popover-close' /> : <MdKeyboardArrowDown className='filters-popover-close' />}
                    </span>
                  )}
                </div>
                
                <div className="sort-controls">
                  <div
                    className={`sort-direction-btn ${sortState.isSelected && sortState.direction === 'ASC' ? 'active' : ''}`}
                    onClick={() => handleSortClick(field.fieldName, 'ASC')}
                    title="Click to add or remove ascending sort"
                  >
                    <LiaSortUpSolid style={{ fontSize: '18px', cursor: 'pointer' }} />
                  </div>
                  <div
                    className={`sort-direction-btn ${sortState.isSelected && sortState.direction === 'DESC' ? 'active' : ''}`}
                    onClick={() => handleSortClick(field.fieldName, 'DESC')}
                    title="Click to add or remove descending sort"
                  >
                    <LiaSortDownSolid style={{ fontSize: '18px' }} />
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SortPopover;
